export const FILTER_BY_CANCELLATION = "FILTER_BY_CANCELLELATION";
export const FILTER_BY_WIFI = "FILTER_BY_WIFI";
export const FILTER_BY_KITCHEN = "FILTER_BY_KITCHEN";
export const FILTER_BY_AC = "FILTER_BY_AC";
export const FILTER_BY_WM = "FILTER_BY_WM";
export const FILTER_BY_IRON = "FILTER_BY_IRON";
export const FILTER_BY_PARKING = "FILTER_BY_PARKING";
export const FILTER_BY_PRICE = "FILTER_BY_PRICE";
export const FILTER_BY_PLACE = "FILTER_BY_PLACE";
export const SHOW_FILTER_DATA = "SHOW_FILTER_DATA";
export const SHOW_SEARCH_PLACE="SHOW_SEARCH_PLACE"
export const GET_PRODUCT_BY_ID="GET_PRODUCT_BY_ID"

export const LOGGEDIN="LOGGEDIN"
export const LOGOUT='LOGOUT'